import { createSlice } from '@reduxjs/toolkit';
import { getCoaches, saveCoach } from './coachesActions';

const initialState = {
  isLoading: false,
  coaches: [],
  error: null,
  success: false,
};

const coachesSlice = createSlice({
  name: 'coaches',
  initialState,
  reducers: {},
  extraReducers: {
    // get coaches
    [getCoaches.pending]: state => {
      state.isLoading = true;
    },
    [getCoaches.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.coaches = payload.data;
    },
    [getCoaches.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // save coach
    [saveCoach.pending]: state => {
      // state.loading = true;
    },
    [saveCoach.fulfilled]: (state, { payload }) => {
      state.coaches = payload.isUpdate.state
        ? state.coaches.map(org => {
            if (org.id === payload.isUpdate.user.id) {
              return payload.userData;
            }
            return org;
          })
        : [payload.data, ...state.coaches];
    },
    [saveCoach.rejected]: (state, { payload }) => {
      // state.loading = false;
      state.error = payload;
    },
  },
});

export default coachesSlice.reducer;
